import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function PhotoFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12.0745 1.5H11.9256C9.74968 1.49998 8.01484 1.49996 6.65471 1.68282C5.25033 1.87164 4.09653 2.27175 3.18414 3.18414C2.27175 4.09653 1.87164 5.25033 1.68282 6.65471C1.49996 8.01484 1.49998 9.74956 1.5 11.9255V12.0745C1.49998 14.2504 1.49996 15.9852 1.68282 17.3453C1.87164 18.7497 2.27175 19.9035 3.18414 20.8159C4.09653 21.7283 5.25033 22.1284 6.65471 22.3172C8.01485 22.5 9.74959 22.5 11.9256 22.5H12.0744C14.2504 22.5 15.9851 22.5 17.3453 22.3172C18.7497 22.1284 19.9035 21.7283 20.8159 20.8159C21.7283 19.9035 22.1284 18.7497 22.3172 17.3453C22.5 15.9852 22.5 14.2504 22.5 12.0744V11.9256C22.5 9.74959 22.5 8.01485 22.3172 6.65471C22.1284 5.25033 21.7283 4.09653 20.8159 3.18414C19.9035 2.27175 18.7497 1.87164 17.3453 1.68282C15.9852 1.49996 14.2504 1.49998 12.0745 1.5ZM5.5 7.5C5.5 6.39543 6.39543 5.5 7.5 5.5C8.60457 5.5 9.5 6.39543 9.5 7.5C9.5 8.60457 8.60457 9.5 7.5 9.5C6.39543 9.5 5.5 8.60457 5.5 7.5ZM6.92183 20.335C6.79989 20.3186 6.68349 20.3008 6.57227 20.2814C8.47707 17.9776 10.4184 15.6499 12.5989 14.1878C13.8589 13.343 15.1548 12.8211 16.5241 12.7568C17.7246 12.7003 19.0389 12.9927 20.4962 13.8125C20.4859 15.1635 20.4512 16.219 20.3356 17.0788C20.1766 18.2614 19.8811 18.9228 19.4023 19.4016C18.9234 19.8805 18.262 20.176 17.0794 20.335C15.8681 20.4979 14.2681 20.5 12.0006 20.5C9.73319 20.5 8.1332 20.4979 6.92183 20.335Z"
				fill="currentColor"
			/>
		</svg>
	);
}

PhotoFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default PhotoFilledIcon;
